export class TimeRegistrationModel  {
    key:string = "";
    _customer:Object = {id: 0, name: "", type: ""};
    _user:Object = {id: 0, fullName: ""};
    _sector:Object = {id: 0, name: ""};
    _department:Object = {id: 0, name: ""};
    _work_type:Object = {};
    _worklog_date:any = new Date();
    _hours:number = 0;
    _minutes:number = 0;
    description:string = "";
    worktype:Object = {id:0, name: ""};
      
        constructor(data = null) {
            if(data) {
            Object.keys(data).map((item) => {
                if(this[item] != undefined) {
                    this[item] = data[item];
                } else {
                    if(item == "tenant_key" && data[item] != "" && data["tenant"]) {
                        this.customer = data["tenant"];
                    } else if(item == "company_key" && data[item] != "" && data["company"]) {
                        this.customer = data["company"];
                    }
                }
            });
            }
        }
public setData(data) {
            if(data) {
            Object.keys(data).map((item) => {
                if(this[item] != undefined) {
                    this[item] = data[item];
                }
            });
            }
}
            
public get customer() {
    return this._customer;
}

public set customer(data: Object) {
//    if (theAge <= 0 || theAge >= 200) {
//        throw new Error('The age is invalid');
//    }
    if(data) {
        let customerType =data["type"];
        if(!data["type"] && data["company_key"]) {
            customerType = "COMPANY";
        } else if(!data["type"] && data["tenant_key"]) {
            customerType = "TENANT";
        }
        
        this._customer = {id: data["key"], name: data["name"], type: customerType};
    } else {
        this._customer = null;
    }
        
}

public set company(data: Object) {
//    if (theAge <= 0 || theAge >= 200) {
//        throw new Error('The age is invalid');
//    }
    if(data) {
    this._customer = {id: data["key"], name: data["name"], type: data["type"]};
    } else {
        this._customer = null;
    }
}

public get user() {
    return this._user;
}

public set user(data: Object) {
    if(data) {
    this._user = {id: data["key"], fullName: data["fullName"]};
    } else {
        this._user = null;
    }
}

public get sector() {
    return this._sector;
}

public set sector(data: any) {
    if(data){
        if( typeof data === 'object' ) {
        this._sector = {key:data.key, name:data.name};
        } else {
            
        }
        //this._department = null;
    } else {
        this._sector = null;
    }
    
}

public get department() {
    return this._department;
}

public set department(data: any) {
    if(data) {
        if( typeof data === 'object' ) {
        this._department = data;
        }
    } else {
        this._department = null;
    }
        
}

public get worklog_date() {
    //let formatted_date = this._worklog_date.getDate() + "-" + (this._worklog_date.getMonth() + 1) + "-" +this._worklog_date.getFullYear();
    return this._worklog_date;
}

public set worklog_date(data: any) {
    if(data) {
        if(data.constructor.name == "Date") {
            this._worklog_date = data;         
        } else {
            let dateItems = data.split("-");
            if(dateItems.length == 3) {
                this._worklog_date = new Date(dateItems[2], (dateItems[1]-1), dateItems[0]);
            }
        }
    }
}

getDatabaseDate(date:any) {
        let formatted_date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" +date.getDate();
        return formatted_date;
}

public get hours() {
    return this._hours;
}

public set hours(data: number) {
    this._hours = data;
}

public get minutes() {
    return this._minutes;
}

public set minutes(data: number) {
    this._minutes = data;
}

public toJsonString(): any {

    //Shallow clone
    let clone: any = Object.assign({}, this); 
    //Find the getter method descriptors
    //Get methods are on the prototype, not the instance
    const descriptors = Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this))

    //Check to see if each descriptior is a get method
    Object.keys(descriptors).forEach(key => {
        if (descriptors[key] && descriptors[key].get) {

            //Copy the result of each getter method onto the clone as a field
            delete clone[key];
            clone[key] = this[key]; //Call the getter
        }
    });

    //Remove any left over private fields starting with '_'
    Object.keys(clone).forEach(key => {
        if (key.indexOf('_') == 0) {
            delete clone[key];
        }
    });

    //toJSON requires that we return an object
    return clone;
}



}